import React, { ReactElement } from 'react';
import { Icons } from '@feast-it/ui/light';
import { useInView } from 'react-intersection-observer';

import { SocialLinksList } from './Components/SocialLinks';
import { LogoComponent } from './Components/LogoComponent';
import { PaymentsGrid } from './Components/PaymentsGrid';
import { SectionLinks } from './Components/SectionLinks';
import { Reviews } from './Components/Reviews';
import { SliceLayout } from '../SliceLayout';
import { Container } from './Footer.styled';

type FooterNavigationItem = {
  text: string;
  href: string;
  onClick?: () => void;
  as?: string;
};

type FooterNavigationGroup = {
  heading: string;
  items: FooterNavigationItem[];
};

export type FooterNavigationRecord = Record<string, FooterNavigationGroup>;

export type FooterSocialLink = {
  type: keyof Icons;
  href: string;
};

interface FooterProps {
  navigation: FooterNavigationRecord;
  paymentTypes: (keyof Icons)[];
  socialLinks: FooterSocialLink[];
}

export function Footer({
  navigation,
  paymentTypes,
  socialLinks,
}: FooterProps): ReactElement {
  const [ref, inView] = useInView({
    threshold: 0,
    triggerOnce: true,
  });

  return (
    <SliceLayout backgroundColor="white" as="footer">
      <Container ref={ref}>
        <Reviews inView={inView} />

        <SectionLinks navigation={navigation} />

        <PaymentsGrid paymentTypes={paymentTypes} />

        <LogoComponent />

        <SocialLinksList socialLinks={socialLinks} />
      </Container>
    </SliceLayout>
  );
}
